import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'route-itinerary-vertical-dots-container',
  templateUrl: './route-itinerary-vertical-dots-container.component.html',
  styleUrls: ['./route-itinerary-vertical-dots-container.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class RouteItineraryVerticalDotsContainerComponent {
  @Input() position: 'start' | 'middle' | 'end' | 'none';

  @Input() iconClass: string = 'fa fa-circle-o';

  @Input() iconSize: 'small' | 'large' = 'large';

  @Input() noIcon: boolean = false;

  @Input() customIcon: string;
}
